var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreSquarespace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A1918;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "squarespace-2",
    className: "st0",
    d: "M61.21,30.38c-1.55-1.55-4.06-1.55-5.6,0c0,0,0,0,0,0L30.38,55.61 c-3.12,3.07-8.14,3.03-11.21-0.09c-3.04-3.09-3.04-8.04,0-11.13l24.75-24.74c-3.1-3.1-8.12-3.1-11.21,0c0,0,0,0,0,0L13.55,38.79 c-6.19,6.19-6.19,16.24,0,22.43s16.24,6.19,22.43,0l25.23-25.24C62.76,34.43,62.76,31.92,61.21,30.38L61.21,30.38z M69.62,21.97 c-6.19-6.19-16.23-6.2-22.42-0.01c0,0,0,0-0.01,0.01L21.97,47.2c-1.52,1.57-1.49,4.08,0.09,5.61c1.54,1.49,3.98,1.49,5.52,0 L52.8,27.57c3.09-3.1,8.11-3.1,11.21,0c0,0,0,0,0,0c1.55,1.55,4.06,1.55,5.61,0C71.17,26.03,71.17,23.52,69.62,21.97L69.62,21.97 L69.62,21.97z M78.03,47.2c-1.55-1.55-4.06-1.55-5.61,0L47.2,72.43c-3.1,3.1-8.12,3.1-11.21,0c-1.55-1.55-4.06-1.55-5.61,0 c-1.55,1.55-1.55,4.06,0,5.61l0,0c6.19,6.19,16.23,6.2,22.43,0c0,0,0,0,0,0L78.04,52.8C79.58,51.26,79.58,48.75,78.03,47.2 L78.03,47.2z M86.45,38.79c-6.19-6.19-16.23-6.19-22.43,0c0,0,0,0,0,0L38.79,64.02c-1.55,1.55-1.55,4.06,0,5.61 c1.55,1.55,4.06,1.55,5.61,0l25.23-25.23c3.12-3.07,8.14-3.03,11.21,0.09c3.04,3.09,3.04,8.04,0,11.12L56.09,80.35 c3.1,3.1,8.12,3.1,11.21,0l19.14-19.14C92.64,55.02,92.64,44.98,86.45,38.79L86.45,38.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreSquarespace);
export default __webpack_public_path__ + "static/media/store-squarespace.00e8526010787f632ed1697c08233bc9.svg";
export { ForwardRef as ReactComponent };